import React, { useCallback } from "react";
import PropTypes from "prop-types";
import subPlans from "venuescanner-js/constants/subscriptions";
import { setFilterOption } from "./filterOptionTypes";
import classes from "./styles.module.scss";
import { VsChk } from "venuescanner-js/react/components/ds/radioAndCheckbox";

const LABEL = "Sub Plan";

export const SubPlanFilterOption = ({ value: selected, onChange }) => {
  const select = useCallback(
    (value) => onChange(new Set(selected).add(value)),
    [onChange, selected]
  );

  const deselect = useCallback(
    (value) => {
      const nextSet = new Set(selected);
      nextSet.delete(value);
      onChange(nextSet);
    },
    [onChange, selected]
  );

  const handleChange = useCallback(
    ({ detail: checked, target: { value } }) => {
      checked ? select(value) : deselect(value);
    },
    [select, deselect]
  );

  return (
    <ul className={classes.SubPlanFilterOption}>
      {Object.values(subPlans).map((subPlan) => (
        <li key={subPlan}>
          <VsChk
            name="subPlan"
            value={subPlan}
            label={subPlan}
            onChange={handleChange}
            checked={selected?.has(subPlan)}
          />
        </li>
      ))}
    </ul>
  );
};

SubPlanFilterOption.propTypes = {
  value: PropTypes.instanceOf(Set),
  onChange: PropTypes.func.isRequired,
};

export default setFilterOption({
  label: LABEL,
  title: "Sub Plan",
  name: "sub_plan",
  getValueLabel: (value) => value?.size,
})(SubPlanFilterOption);
